import { NewsContentType } from '@/types/enum';
import image1 from '@/assets/images/news/detail/20220117/1.jpg';
import image2 from '@/assets/images/news/detail/20220117/2.jpg';
import image3 from '@/assets/images/news/detail/20220117/3.jpg';
import image4 from '@/assets/images/news/detail/20220117/4.jpg';
import image5 from '@/assets/images/news/detail/20220117/5.jpg';
import image6 from '@/assets/images/news/detail/20220117/6.jpg';
import image7 from '@/assets/images/news/detail/20220117/7.jpg';
import image8 from '@/assets/images/news/detail/20220117/8.jpg';
import image9 from '@/assets/images/news/detail/20220117/9.jpg';
import image10 from '@/assets/images/news/detail/20220117/10.jpg';
import image11 from '@/assets/images/news/detail/20220117/11.jpg';
import image12 from '@/assets/images/news/detail/20220117/12.jpg';
import image13 from '@/assets/images/news/detail/20220117/13.jpg';

export default {
  id: '20220117', //  模块 id
  title: '虎力全开 2022新春游园会精彩瞬间回顾', // 标题
  origin: '', // 新闻来源
  editor: '', // 编辑者
  content: [
    {
      type: NewsContentType.Text,
      text: '2022叮咚买菜新春游园会活动回顾来啦！',
    },
    {
      type: NewsContentType.Text,
      text: '一起来看看活动现场吧！',
    },
    {
      type: NewsContentType.Image,
      src: [image1],
    },
    {
      type: NewsContentType.Text,
      text: '根据集章任务卡提示完成任务',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '新年有心愿',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '活动开始不久',
    },
    {
      type: NewsContentType.Text,
      text: '许愿树上就挂满了',
    },
    {
      type: NewsContentType.Text,
      text: '大家对家人朋友的美好祝福',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '定格美好',
    },
    {
      type: NewsContentType.Image,
      src: [image2, image3],
    },
    {
      type: NewsContentType.Text,
      text: '定格美好瞬间',
    },
    {
      type: NewsContentType.Text,
      text: '新年更要加油鸭~',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '叮咚知多少',
    },
    {
      type: NewsContentType.Image,
      src: [image4],
    },
    {
      type: NewsContentType.Text,
      text: '考验你对叮咚了解有多少',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '手写送福',
    },
    {
      type: NewsContentType.Image,
      src: [image5],
    },
    {
      type: NewsContentType.Text,
      text: '创意福字书写新春',
    },
    {
      type: NewsContentType.Text,
      text: '把福气带回家',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '手眼并用',
    },
    {
      type: NewsContentType.Image,
      src: [image6],
    },
    {
      type: NewsContentType.Text,
      text: '欢乐套圈儿',
    },
    {
      type: NewsContentType.Text,
      text: '比比谁的技术好',
    },
    {
      type: NewsContentType.Image,
      src: [image7],
    },
    {
      type: NewsContentType.Text,
      text: '不一会儿4个印章就集齐了',
    },
    {
      type: NewsContentType.Text,
      text: '抽奖区挤满排队抽奖的小伙伴',
    },
    {
      type: NewsContentType.Image,
      src: [image8, image9],
    },
    {
      type: NewsContentType.Image,
      src: [image10, image11],
    },
    {
      type: NewsContentType.Text,
      text: '游园玩游戏',
    },
    {
      type: NewsContentType.Text,
      text: '自然也少不了美食',
    },
    {
      type: NewsContentType.Text,
      text: '温泉蛋、酸汤肥牛、火锅四宫格、酸奶布丁',
    },
    {
      type: NewsContentType.Text,
      text: '颜值口味都是一级棒！',
    },
    {
      type: NewsContentType.Image,
      src: [image12],
    },
    {
      type: NewsContentType.Text,
      text: '最受欢迎的是新年循环市集',
    },
    {
      type: NewsContentType.Text,
      text: '摊位上满是摊主们精挑细选的',
    },
    {
      type: NewsContentType.Text,
      text: '玩具、书籍、化妆品……',
    },
    {
      type: NewsContentType.Image,
      src: [image13],
    },
    {
      type: NewsContentType.Text,
      text: '最终5号摊位获得最佳人气摊位奖',
    },
    {
      type: NewsContentType.Text,
      text: '恭喜恭喜~',
    },
    {
      type: NewsContentType.EmptyLine,
    },
    {
      type: NewsContentType.Text,
      text: '最后',
    },
    {
      type: NewsContentType.Text,
      text: '希望大家在新的一年',
    },
    {
      type: NewsContentType.Text,
      text: '爱与成长同在',
    },
    {
      type: NewsContentType.Text,
      text: '让每一个渺小的日子都闪出光亮',
    },
    {
      type: NewsContentType.Text,
      text: '祝小伙伴们新春快乐！',
    },
  ],
};
